import styled, {keyframes} from "styled-components"

export const Wrapper = styled.div`
  position:absolute;
  width:100%;
  left:0;
  bottom:0;
  height:12%;
  background:black;
`

const timeBar = keyframes`
0%{width:100%; background:orange;}
100%{width:0%; background: red;}
`

export const TimeBar = styled.div`
  position:absolute;
  left:0;
  bottom:0;
  top:0;
  animation: ${timeBar} 40s linear both .5s;
`